export function splitStringByWord(text: string, word: string, caseSensitive = true) {
  if (!caseSensitive) {
    const regex = new RegExp(`(${word})`, 'i'); // Case-insensitive regex
    const match = regex.exec(text);

    if (match) {
      return {
        before: text.substring(0, match.index),
        match: match[0], // Preserve original casing
        after: text.substring(match.index + match[0].length),
      };
    }
  } else {
    const index = text.indexOf(word);
    if (index !== -1) {
      return {
        before: text.substring(0, index),
        match: word,
        after: text.substring(index + word.length),
      };
    }
  }

  return { before: text, match: null, after: null };
}
